import axios from 'axios';

const Axios = axios.create({
  baseURL: process.env.REACT_APP_BASE_BACKEND_URL,
  withCredentials: true
});

export default Axios;
